module.exports = __webpack_public_path__ + "img/unicomCourse.88e06fca.png";